export default function DisclaimerStrip() {
  return (
    <div className="disclaimer-strip">
      <div className="container">
        <p>
          <i className="fa-solid fa-circle-info" /> Our products are natural dietary supplements intended to support
          general wellness. They are not a substitute for professional medical advice, diagnosis or treatment. Always
          consult a qualified healthcare provider for any condition.
        </p>
      </div>
    </div>
  );
}
